import React from "react";
import GoldenButton from "../assets/images/add to my order button.svg"
const baseSubscribePackage = {
  title: "Subscribe & Save Package",
  price: 0,
  shipping: "$29.95 SHIPPING",
  after30Days: "then $67/mo after 30 days",
  buttonLink: "https://scalequick.pay.clickbank.net/?cbitems=13&cbur=a&cbrblaccpt=true",
  
  isSubscribe: true,
};
// a 
const packages = [
  {
    ...baseSubscribePackage,
    id: 1,
    isVisibleOnMd: true,
  },
  {
    ...baseSubscribePackage,
    id: 2,
    isVisibleOnMd: false,
  },
  {
    id: 3,
    title: "Regular Package",
    price: 77,
    shipping: "$29.95 SHIPPING",
    after30Days: "one time fee, no subscription",
    buttonLink: "https://scalequick.pay.clickbank.net/?cbitems=12&cbur=a",
    isSubscribe: false,
  },
];

const SpecialOfferPlans = () => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl mx-auto p-4 place-items-center">
        {packages.map((pkg) => (
          <div
            key={pkg.id}
            className={`${
              pkg.isVisibleOnMd === false
                ? "block md:hidden"
                : pkg.isVisibleOnMd === true
                ? "hidden md:block"
                : ""
            } bg-white overflow-hidden self-center rounded-[12px]`}
            style={{
              border: pkg.isSubscribe
                ? "3px solid #c79d4c80"
                : "3px solid #233751",
              boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.25)",
            }}
          > 
            <div 
              className={`text-white p-4 flex items-center flex-col ${
                pkg.isSubscribe ? "subscribe-bg" : "bg-[#233751]" 
              }`}
            >
              <h2 className="text-xl lg:text-[24px] font-bold">{pkg.title}</h2>
            </div>
            <div className="p-4 bg-white">
              <div className="flex justify-center mb-4 mt-8">
                <img  
                   src={
                      pkg.isSubscribe
                        ? "https://media.fileverge.com/yNW-subsbox.svg"
                        : "https://media.fileverge.com/t7y-onetimebox.svg"
                    }
                  alt="Vitality Box"
                  className="h-full w-full"
                /> 
              </div> 
              <p className="text-[#7A7C7B] text-[16px] text-center font-bold leading-[28px]">
                Regular Price:
                <span className="relative inline-block">
                  <span className="text-[16px] text-[#7A7C7B]">$620.75</span>
                  <span className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <span className="block w-[90%] h-[2px] bg-[#690C0C] rotate-[8deg]"></span> 
                  </span>
                </span>
              </p>
              <p className="text-[#AB7C3B] font-bold text-[24px] text-center leading-[28px] bold-font"> 
                YOUR VIP RATE
              </p>
              <div className="relative leading-[28px]"> 
                <div className="text-[#233751] rounded-[6px] flex items-center justify-center">
                  <span
                    className={`text-[16px] font-bold bottom-[3.5px] absolute left-1/2 transform ${
                      pkg.price >= 0 && pkg.price <= 9 ? "translate-x-negative" : "translate-x-positive" 
                    }`}
                  >
                    $
                  </span>
                  <span className="text-[32px] font-bold">{pkg.price}</span>
                </div>
              </div>
              {pkg.isSubscribe && (
                <>
                  <p className="text-[#233751] text-[16px] font-bold mt-2 text-center pt-3 bold-font">
                    CLAIM YOUR VOUCHER & SAVE NOW!
                  </p>
                  <div className="flex justify-center border-2 border-dashed md:mx-3 mx-5 p-1 mt-2">
                    <img
                      src="https://cdn.blackincae.com/czb-golden-boucher-1-1-.svg"
                      alt=""
                    />
                  </div>
                </>
              )}
              <div className="flex items-center justify-center gap-1 mt-2">
                <img src="https://media.fileverge.com/Gno-shipped.svg" alt="" />
                <p className="text-[#000000] text-[14px] text-center">
                  {pkg.shipping}
                </p>
              </div>
              <p className="text-[#000000] text-[16px] text-center font-black uppercase bold-font">
                {pkg.after30Days}
              </p>
              <div className="flex items-center justify-center pt-3 transition ease-in-out duration-300 hover:translate-y-[2px]">
                <a href={pkg.buttonLink}>
                  <img
                    src={
                      pkg.isSubscribe
                        ? "https://cdn.blackincae.com/Q5l-frame-263.svg"
                        : "https://cdn.blackincae.com/5By-frame-217.svg"
                    }
                    alt=""
                    draggable="false"
                    className="w-full"
                  />
                </a>
              </div>

              <div className="flex items-center justify-center pt-2">
                <a href="#">
                  <img
                    src="https://cdn.blackincae.com/NW2-image-2.png"
                    alt=""
                    draggable="false"
                  />
                </a>
              </div>
            </div>

            <div
              className={`text-white p-2 flex items-center flex-col ${
                pkg.isSubscribe ? "subscribe-bg" : "bg-[#233751]"
              }`}
            >
              <h2 className="text-[14px] font-bold italic">
                {pkg.isSubscribe
                  ? "(Can be canceled at any time)"
                  : "(One Time Payment)"}
              </h2>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default SpecialOfferPlans;
